import styled from "styled-components";

export const LabelItemContract = styled.label`
  font-family: Open Sans;
  font-weight: 600;
  font-size: 20px;
`;
